import { Col, Row, Typography } from 'antd'
import React from 'react'

const {Text} = Typography;
export default function GameLogExpandable({record}) {
  return (
    <Col>
      <Row gutter={[16, 16]}>
        <Col span={4}>
          <Text>ID : &nbsp;</Text>
        </Col>
        <Col span={20}>
          <Text copyable>{record.id}</Text>
        </Col>

        <Col span={4}>
          <Text>game_id</Text>
        </Col>
        <Col span={20}>
          <Text copyable>{record.game_id}</Text>
        </Col>

        <Col span={4}>
         <Text>Reference ID : &nbsp;</Text>
        </Col>

        <Col>
          <Text copyable>{record.ref_id}</Text>
        </Col>
      </Row>
    </Col>
  )
}
